export const generateUID = (maxLength = 15) => {
  const uid = Date.now() + (Math.random() * 10000).toFixed();
  const startIdx = Math.max(uid.length - maxLength, 0);
  return uid.substring(startIdx);
};

// Capitalizes first letter in a word
export const capitalize = (value) => {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const emptyDisplay = "--";
